/*
 *  Login Register
 *    Basic scripts for the login-register template. 
 *
 *
 *  Version:
 *    1.0.0 - 2023/07/27
 */

import $ from 'jquery';

export const TEMPLATE_SELECTOR = '[data-login-register]';

export const RESET_PASSWORD_TOGGLE = '[data-reset-password-toggle]';
export const LOGIN_FORM_SELECTOR = '[data-login-form]';
export const RESET_FORM_SELECTOR = '[data-reset-password-form]';

export const CLASS_VISIBLE = 'is-visible';

class LoginRegister {
  constructor(container) {
    this.container = container;

    this.loginForm = container.find(LOGIN_FORM_SELECTOR);
    this.resetForm = container.find(RESET_FORM_SELECTOR);
    this.forms = [this.loginForm, this.resetForm];

    container.on('click touchend', RESET_PASSWORD_TOGGLE, e => this.onFormToggle(e));

    this.onEmailNoFound();
  }

  onEmailNoFound(){
    if(window.location.href.indexOf('#recover') !== -1) {
      this.forms.forEach(e => e.toggleClass(CLASS_VISIBLE));
    }
  }

  onFormToggle(e){
    e.preventDefault();
    e.stopPropagation();

    this.forms.forEach(e => e.toggleClass(CLASS_VISIBLE));
  }
}

//Initialize
$(document).ready($(TEMPLATE_SELECTOR).each((e,i) => new LoginRegister($(i))));